export const generateDDLEvent = ({
  reactlytics = {},
  elementProp,
  typeProp,
  detailProp,
}) => {
  const { element, type, detail } = reactlytics;

  return {
    element: element || elementProp,
    type: type || typeProp,
    detail: detail || detailProp,
  };
};

export const getTargetNodeName = (syntheticEvent) =>
  syntheticEvent?.nativeEvent?.target?.nodeName?.toLowerCase();

const customHandlerCreators = {
  onClick: (track, _handler, props) => (syntheticEvent) => {
    const { id, type, reactlytics } = props;

    if (reactlytics?.disable) {
      return;
    }

    const defaultElement = getTargetNodeName(syntheticEvent);

    const event = generateDDLEvent({
      reactlytics,
      elementProp: type || defaultElement,
      typeProp: 'click',
      detailProp: id,
    });

    track({ event });
  },
  default: (track, _handler, props) => (syntheticEvent) => {
    const { id, reactlytics } = props;

    if (reactlytics?.disable) {
      return;
    }

    const defaultElement = getTargetNodeName(syntheticEvent);

    const event = generateDDLEvent({
      reactlytics,
      elementProp: defaultElement,
      typeProp: reactlytics?.type || 'event',
      detailProp: id,
    });

    track({ event });
  },
};

export default customHandlerCreators;
